import { useState } from 'react';

import { CrossdockingContext, initialState } from './CrossdockingContext';
import { useSelector } from 'react-redux';

export const CrossdockingProvider = ({ children }) => {
  const { activeRoute } = useSelector((state) => state.routes);
  const [filters, setFilters] = useState({
    ...initialState.filters,
    idRoute: activeRoute?.idRoute || '',
  });

  const [openBarcodeScanner, setOpenBarcodeScanner] = useState(false);
  const [openManualReceiving, setOpenManualReceiving] = useState(false);

  return (
    <CrossdockingContext.Provider
      value={{
        filters,
        setFilters,
        openBarcodeScanner,
        setOpenBarcodeScanner,
        openManualReceiving,
        setOpenManualReceiving,
      }}
    >
      {children}
    </CrossdockingContext.Provider>
  );
};
